export default __webpack_public_path__ + "img/f80a436d3bccf5be609a72c352e57f35.png";